export enum pageStates {
  alreadySignedUp = "alreadySignedUp",
  canSignUp = "canSignUp",
  showForm = "showForm",
  upgrade = "upgrade",
  notPurchased = "notPurchased",
}
